var React = require('react');

function DecoBlob19 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M703.5 1069C463.171 904.254 276.188 1033.56 165.509 944C34.517 837.999 2.42679 593.436 500.117 450.365C997.808 307.294 1217 376 1366 506.5C1487.22 634.5 1577.59 789.5 1435.5 968.5C1283.49 1160 907 1208.5 703.5 1069Z","fill":"#2D63D7"}));
}

DecoBlob19.defaultProps = {"width":"1624","height":"1580","viewBox":"0 0 1624 1580","fill":"none"};

module.exports = DecoBlob19;

DecoBlob19.default = DecoBlob19;
